module.exports = __webpack_public_path__ + "img/music2.62054870.png";